/* eslint-disable no-console */

import {register} from "register-service-worker"

const kioskMode = new URLSearchParams(window.location.search).get(`display`) === `kiosk` || localStorage.getItem(`kiosk`) === `yes`;

if (window.env.VUE_APP_ENV !== `local` && kioskMode) {
    register(`${process.env.BASE_URL}service-worker.js`, {
        ready() {
            console.log(
                `App is being served from cache by a service worker.\n` +
                `For more details, visit https://goo.gl/AFskqB`
            )
        },
        registered() {
            console.log(`Service worker has been registered.`)
        },
        cached() {
            console.log(`Content has been cached for offline use.`)
        },
        updatefound() {
            console.log(`New content is downloading.`)
        },
        updated() {
            console.log(`New content is available; reloading to apply the new version.`)
            // A new deploy rotates the precached chunk hashes (cleanupOutdatedCaches), but the
            // runtime-cached index.html still references the old ones: without a reload the next
            // offline navigation serves stale HTML pointing to chunks that no longer exist in cache.
            // Reloading now (we are online, the new service worker was just downloaded) re-fetches and
            // re-caches an index.html that matches the new precache. Guarded against reload loops.
            const lastReload = parseInt(sessionStorage.getItem(`swUpdateReload`) || `0`);
            if (Date.now() - lastReload > 30000) {
                sessionStorage.setItem(`swUpdateReload`, `${Date.now()}`);
                window.location.reload();
            }
        },
        offline() {
            console.log(`No internet connection found. App is running in offline mode.`)
        },
        error(error) {
            console.error(`Error during service worker registration:`, error)
        }
    });
}
